var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoporationImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 72,
    viewBox: "0 0 62 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.59995 9.5998C4.59995 7.2659 5.52709 5.02758 7.17741 3.37726C8.82773 1.72694 11.066 0.799805 13.4 0.799805H48.6C50.9339 0.799805 53.1722 1.72694 54.8225 3.37726C56.4728 5.02758 57.4 7.2659 57.4 9.5998V62.3998C58.5669 62.3998 59.6861 62.8634 60.5112 63.6885C61.3364 64.5137 61.8 65.6329 61.8 66.7998C61.8 67.9668 61.3364 69.0859 60.5112 69.9111C59.6861 70.7362 58.5669 71.1998 57.4 71.1998H44.2C43.033 71.1998 41.9138 70.7362 41.0887 69.9111C40.2635 69.0859 39.8 67.9668 39.8 66.7998V57.9998C39.8 56.8329 39.3364 55.7137 38.5112 54.8885C37.6861 54.0634 36.5669 53.5998 35.4 53.5998H26.6C25.433 53.5998 24.3138 54.0634 23.4887 54.8885C22.6635 55.7137 22.2 56.8329 22.2 57.9998V66.7998C22.2 67.9668 21.7364 69.0859 20.9112 69.9111C20.0861 70.7362 18.9669 71.1998 17.8 71.1998H4.59995C3.433 71.1998 2.31384 70.7362 1.48868 69.9111C0.663521 69.0859 0.199951 67.9668 0.199951 66.7998C0.199951 65.6329 0.663521 64.5137 1.48868 63.6885C2.31384 62.8634 3.433 62.3998 4.59995 62.3998V9.5998ZM17.8 13.9998H26.6V22.7998H17.8V13.9998ZM26.6 31.5998H17.8V40.3998H26.6V31.5998ZM35.4 13.9998H44.2V22.7998H35.4V13.9998ZM44.2 31.5998H35.4V40.3998H44.2V31.5998Z",
    fill: "#8DAA6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoporationImage);
export default __webpack_public_path__ + "static/media/coporationImage.20d27113756c71f3f6f57e15ad3988c6.svg";
export { ForwardRef as ReactComponent };